export default __webpack_public_path__ + "static/pro_Strategy_Mobile-e31807c9bb7360927660ae48866f4f85.png";